import { render, staticRenderFns } from "./core.vue?vue&type=template&id=536f98cf&scoped=true&"
import script from "./core.vue?vue&type=script&lang=js&"
export * from "./core.vue?vue&type=script&lang=js&"
import style0 from "./core.vue?vue&type=style&index=0&id=536f98cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536f98cf",
  null
  
)

export default component.exports